// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectedItem_wrapper__rx7ov","col1":"SelectedItem_col1___oPuy","truncateText":"SelectedItem_truncateText__7qjwX"};